<template>
  <div class="control-group">
    <span class="control-group__label" :class="`control-group__label--${tone}`">{{ label }}</span>
    <div class="control-group__row">
      <slot />
    </div>
  </div>
</template>

<script setup>
// A labeled cluster of controls in the event bar — the small uppercase eyebrow
// ("EVENT", "ITEM · RUN ORDER") over the row it names.
//
// SLOTS
//   default — the controls.
defineOptions({ name: 'ControlGroup' });

defineProps({
  label: { type: String, required: true },
  // neutral | danger — danger marks the cluster that can stop the sale.
  tone: { type: String, default: 'neutral', validator: (value) => ['neutral', 'danger'].includes(value) },
});
</script>

<style scoped>
.control-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: var(--p-control-group-gap);
  padding: var(--p-control-group-padding);
}

.control-group__label {
  font-size: var(--p-control-group-label-font-size);
  font-weight: var(--p-control-group-label-font-weight);
  letter-spacing: var(--p-control-group-label-letter-spacing);
  padding-left: var(--p-control-group-label-padding-left);
  text-transform: uppercase;
}

.control-group__label--neutral {
  color: var(--p-control-group-label-neutral-color);
}

.control-group__label--danger {
  color: var(--p-control-group-label-danger-color);
}

.control-group__row {
  display: flex;
  align-items: center;
  gap: var(--p-control-group-row-gap);
}
</style>
